module.exports = __webpack_public_path__ + "static/img/photo_2.48c99ac.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img_bole/photo_2.jpg
// module id = tRdY
// module chunks = 1